const ROLLOUTS = {
    GIG_IDS_REDIS: 'foxes_gig_page_ids_redis',
    LIONS_STICKY_MT: 'lions_sticky_mt',
    LIONS_GIG_CARD_FORMATTING: 'lions_gig_card_formatting',
    CHAM_V5_GIG_PAGE_VIEWS_FLOW: 'cham_v_five_gig_page_views_flow',
    QUAL_REVIEWS_INDUSTRIES: 'qualas_reviews_industries_filter',
    QUAL_REVIEWS_SORT_BY_COUNTRY: 'qualas_reviews_sort_by_country',
    QUAL_REVIEWS_MOBILE_WEB: 'qualas_reviews_web_mobile',
    QUAL_REVIEWS_LOYALTY: 'qualas_reviews_loyalty',
    QUAL_REVIEWS_SNIPPET_ALGO: 'qualas_reviews_snippet_algo',
    STICKY_SIDEBAR: 'foxes_sticky_sidebar',
    GIG_PAGE_SBSS_INDICATION: 'qualas_gig_page_sbss_indication',
    FOXES_CREATE_BRIEF: 'foxes_create_new_brief_page',
    FOXES_CONTACT_SELLER_OPTIONS: 'foxes_contact_seller_options'
};

const ROLLOUT_STATUS = {
    CLOSED: 0,
    ACTIVE: 1
};

module.exports = {
    ROLLOUTS,
    ROLLOUT_STATUS
};
